import Vue from 'vue'; // Import Vue into Project
import App from '@/App.vue'; // Import Vue App Into Project
import router from '@/router.js'; // Import Vue-Router into Project
import store from '@/store.js'; // Import Vuex Store into Project

// * VEUTIFY AND GLOBAL STYLES / ICONS / ANIMATIONS
import vuetify from '@/vuetify.js';
import "@/assets/css/styles.min.css"; // Import Icons8 Font Library CSS file
import '../node_modules/animate.css/animate.min.css'; // import animate css

// * GLOBAL MIXIN
import mixin from './mixin.js';
Vue.use(mixin);

// * FIREBASE INTEGRATION
const firebase = require("@/firebase/firebase-config.js"); // Import Firebase Config for Firebase Object Access
Vue.prototype.$firebase = firebase; // Prototype Firebase for use throughout Project $firebase

// * REQUIRE MODULES
require('./modules/firebase/firebase_import.js') // Require Firebase Components and Mixins
require('./modules/progressBar/progressBar_import.js'); 
require('./modules/appUpdate/appUpdate_import.js') // Require App Update Components and Mixins

import appupdate_mixin from '@/modules/appUpdate/appUpdate_mixin.js';
Vue.use(appupdate_mixin);

// * APP UPDATE COMPONENT
import AppUpdate from '@/modules/appUpdate/appUpdate_component.vue';
Vue.component('AppUpdate', AppUpdate);



// * SERVICE WORKER INTEGRATION
import '@/registerServiceWorker';
import sw_mixin from '@/sw_mixin.js'; // Import Service Work Mixing for Global SW Functions
Vue.use(sw_mixin); // Use Service Worker Mixing within Vie

// alertbox mixin import and use
import alertbox_mixin from '@/modules/alertbox/alertbox_mixin.js';
Vue.use(alertbox_mixin);

// * CSV Import Component
import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)
// alertbox component import and register
import alertbox_component from '@/modules/alertbox/alertbox_component.vue';
Vue.component('alertbox', alertbox_component);

//confirmation mixin import and register
import confirmation_mixin from '@/modules/confirmation/confirmation_mixin.js';
Vue.use(confirmation_mixin);

//  confirmation component import and register
import confirmation_component from '@/modules/confirmation/confirmation_component.vue';
Vue.component('confirmation', confirmation_component);

// * MENU ITEMS LIST
import menu_list from '@/components/structural/menu-list.vue';
Vue.component('menuList', menu_list);

// * MOBILE MENU ITEMS LIST
import mobile_menu_list from '@/components/structural/mobile-menu-list.vue';
Vue.component('mobileMenuList', mobile_menu_list);

// * DATE PICKER
import datePicker_mixin from '@/modules/datePicker/datePicker_mixin.js';
Vue.use(datePicker_mixin);
import datePicker_component from '@/modules/datePicker/datePicker_component.vue';
Vue.component('datePicker', datePicker_component);

// * COMMENTS
import comment_mixin from '@/modules/comment/comment_mixin.js';
Vue.use(comment_mixin);
import comment_component from '@/modules/comment/comment_component.vue';
Vue.component('comment', comment_component);

// * LOCATIONS
import location_mixin from '@/modules/location/location_mixin.js';
Vue.use(location_mixin);
import location_component from '@/modules/location/location_component.vue';
Vue.component('location', location_component);


// * FS DIALOG - Full Screen Dialog with Dynamic Component
import fsDialog_mixin from '@/modules/fsDialog/fsDialog_mixin.js';
Vue.use(fsDialog_mixin);
import fsDialog_component from '@/modules/fsDialog/fsDialog_component.vue';
Vue.component('fsdialog', fsDialog_component);
import fsDialog_test from '@/modules/fsDialog/fsDialog_test.vue';
Vue.component('fsdialogtest', fsDialog_test);

// * PU DIALOG - Popup Screen Dialog with Dynamic Component
import puDialog_mixin from '@/modules/puDialog/puDialog_mixin.js';
Vue.use(puDialog_mixin);
import puDialog_component from '@/modules/puDialog/puDialog_component.vue';
Vue.component('pudialog', puDialog_component);
import puDialog_test from '@/modules/puDialog/puDialog_test.vue';
Vue.component('pudialogtest', puDialog_test);

import VueQrcodeReader from "vue-qrcode-reader";
Vue.use(VueQrcodeReader);


// ! NEED TO 
// scan qr code component
import qr_code_reader from '@/modules/qr-code-reader/qr_code_reader_component.vue';
Vue.component('qrCodeReader', qr_code_reader);

//generate qr code mixin
import qr_code_reader_mixins from '@/modules/qr-code-reader/qr_code_reader_mixin.js';
Vue.use(qr_code_reader_mixins);

// generate qr code component dialog
import qr_code_generator_dialog from '@/modules/qr-code-generator/qr_code_generator_dialog_component.vue';
Vue.component('qrCodeGeneratorDialog', qr_code_generator_dialog);

// generate qr code component card
import qr_code_generator_card from '@/modules/qr-code-generator/qr_code_generator_card_component.vue';
Vue.component('qrCodeGeneratorCard', qr_code_generator_card);

 //generate qr code mixin
import qr_code_generator_mixins from '@/modules/qr-code-generator/qr_code_generator_mixin.js';
Vue.use(qr_code_generator_mixins);
// ! NEED TO 

//upload files component
import dragdrop from "@/modules/file-upload/drag-drop.vue";
Vue.component('dragdrop', dragdrop);
import uploadFilesButton from "@/modules/file-upload/upload-files-button.vue";
Vue.component('uploadFilesButton', uploadFilesButton);

//preview files component
import filePreviewer from "@/modules/file-preview/previewer.vue";
Vue.component('filePreviewer', filePreviewer);

// // * AUTH COMPONENTS IMPORT
// // TFW Employee Email Address Component
// import tfw_email from '@/components/auth/tfw-employee/email-address/tfw_email.vue';
// Vue.component('tfwEmail', tfw_email);

// // Contractor Company Details
// import contractor_company_details from '@/components/auth/contractor/company/company_details.vue';
// Vue.component('contractorCompanyDetails', contractor_company_details);

// // Contractor Contact Details
// import contractor_contact_details from '@/components/auth/contractor/contact-details/contractor_contact_details.vue';
// Vue.component('contractorContactDetails', contractor_contact_details);

// // Visitor Company Details
// import visitor_company_details from '@/components/auth/visitor/company/visitor_company_details.vue';
// Vue.component('visitorCompanyDetails', visitor_company_details);

// // Visitor Contact Details
// import visitor_contact_details from '@/components/auth/visitor/contact-details/visitor_contact_details.vue';
// Vue.component('visitorContactDetails', visitor_contact_details);

// // TFW Employee Contact Details Component
// import tfw_contact_details from '@/components/auth/tfw-employee/contact-details/tfw_contact_details.vue';
// Vue.component('tfwContactDetails', tfw_contact_details);

import moment from "moment";
import i18n from './i18n'; // language translator form


Vue.config.productionTip = false;



//lodash
import _ from "lodash-es";
import groupBy from "lodash-es/groupBy";
import find from "lodash-es/find";
import filter from "lodash-es/filter";
import sortBy from "lodash-es/sortBy";
// import orderBy from "lodash-es/orderBy";
import uniqBy from "lodash-es/uniqBy";
import uniq from "lodash-es/uniq";
import map from "lodash-es/map";
import has from "lodash-es/has";
import pick from "lodash-es/pick";
import omit from "lodash-es/omit";
import unionBy from "lodash-es/unionBy";
import reduce from "lodash-es/reduce";

import axios from 'axios';
Vue.prototype.$axios = axios;

// import QrScanner from 'qr-scanner';
//Object.defineProperty(Vue.prototype, '$QrScanner', { value: QrScanner });
// Vue.prototype.$QrScanner = QrScanner;


// import jsQR from "jsqr";
// Vue.prototype.$jsQR = jsQR;


// import includes from "lodash-es/includes";

Vue.prototype.$_ = _;

Vue.prototype.$groupBy = groupBy;
Vue.prototype.$omit = omit;
Vue.prototype.$has = has;
Vue.prototype.$uniqBy = uniqBy;
Vue.prototype.$uniq = uniq;
Vue.prototype.$filter = filter;
Vue.prototype.$pick = pick;
Vue.prototype.$find = find;
Vue.prototype.$sortBy = sortBy;
Vue.prototype.$reduce = reduce;
Vue.prototype.$moment = moment;

//Vue.prototype.$orderBy = orderBy;
Vue.prototype.$map = map;

// * GLOBAL COMPONENTS
import appbutton from './components/base/app_button.vue';
Vue.component('appbutton', appbutton)
import appcopyright from './components/base/app_copyright.vue';
Vue.component('appcopyright', appcopyright)
import app_text from './components/base/app_text.vue';
Vue.component('app-text', app_text)
import printPass from './components/base/printPass.vue';
Vue.component('printPass', printPass)
import printAccess from './components/base/printAccess.vue';
Vue.component('printAccess', printAccess)
import printRollCall from './components/base/printRollCall.vue';
Vue.component('printRollCall', printRollCall)

// import documentslist from "./components/documents/documents.vue";
// Vue.component('documentslist', documentslist)

// import desktopviewdocument from "./components/documents/document-view-desktop.vue";
// Vue.component('desktopviewdocument', desktopviewdocument)
// import mobileviewdocument from "./components/documents/document-view-mobile.vue";
// Vue.component('mobileviewdocument', mobileviewdocument)

// import documentNew from "./components/projects/documents/document-new.vue";
// Vue.component('document-new', documentNew)


// * BLANK COMPONENT
import blank from "./components/blank.vue";
Vue.component('blank', blank)


// * PROJECT COMPONENTS
import projectNew from "./components/project.vue";
Vue.component('project', projectNew)

// * DOCUMENT COMPONENTS
import document from "./components/document.vue";
Vue.component('document', document)

// * USER COMPONENTS
import user from "./components/user.vue";
Vue.component('user', user)

// * ORGANISATION COMPONENTS
import organisation from "./components/organisation.vue";
Vue.component('organisation', organisation)

// * SLIDES COMPONENTS
import slide from "./components/slide.vue";
Vue.component('slide', slide);

// * QUESTION COMPONENTS
import question from "./components/question.vue";
Vue.component('question', question);

// * GUIDES COMPONENTS
import guide from "./components/guide.vue";
Vue.component('guide', guide);

// * SITE COMPONENTS
import site from "./components/site.vue";
Vue.component('site', site)
// * CONCERN COMPONENTS
import concern from "./components/concern.vue";
Vue.component('concern', concern)
// * NOTICE COMPONENTS
import notice from "./components/notice.vue";
Vue.component('notice', notice)

// * FIRE ROLL CALL COMPONENTS
import fireRollCall from "./components/fireRollCall.vue";
Vue.component('fireRollCall', fireRollCall)
import fireRollCallRegister from "./components/fireRollCallRegister.vue";
Vue.component('fireRollCallRegister', fireRollCallRegister)
import fireRollCallUserCard from "./components/fireRollCallUserCard.vue";
Vue.component('fireRollCallUserCard', fireRollCallUserCard)
import fireRollCallUserCardPrint from "./components/fireRollCallUserCardPrint.vue";
Vue.component('fireRollCallUserCardPrint', fireRollCallUserCardPrint)

// * PASS COMPONENTS
import pass from "./components/pass.vue";
Vue.component('pass', pass)

// * SITE ACCESS COMPONENTS
import access from "./components/access.vue";
Vue.component('access', access)

// * FIRESELECTED COMPONENTS
import fireSelected from "./modules/fireSelected/fireSelected_component.vue";
Vue.component('fireselected', fireSelected)
import fireSelected_mixin from '@/modules/fireSelected/fireSelected_mixin.js';
Vue.use(fireSelected_mixin);

// * PHOTOUPLOAD COMPONENTS
import photoUpload from "./modules/photoUpload/photoUpload_button_component.vue";
Vue.component('photoupload', photoUpload)
// * PHOTOUPLOAD MIXINS
import photoUpload_mixin from '@/modules/photoUpload/photoUpload_mixin.js';
Vue.use(photoUpload_mixin);

// * PHOTOVIEWER COMPONENTS
import photoViewer from "./modules/photoViewer/photoViewer_component.vue";
Vue.component('photoviewer', photoViewer)
// * PHOTOUPLOAD MIXINS
import photoViewer_mixin from '@/modules/photoViewer/photoViewer_mixin.js';
Vue.use(photoViewer_mixin);

// * DOCVIEWER COMPONENTS
import docViewer from "./modules/docViewer/docViewer_component.vue";
Vue.component('docviewer', docViewer)
// * DOCVIEWER MIXINS
import docViewer_mixin from '@/modules/docViewer/docViewer_mixin.js';
Vue.use(docViewer_mixin);

// * DOCUPLOAD COMPONENTS
import docUploadButton from "./modules/docUpload/docUpload_button_component.vue";
Vue.component('docuploadbutton', docUploadButton)
// * DOCUPLOAD MIXINS
import docUpload_mixin from '@/modules/docUpload/docUpload_mixin.js';
Vue.use(docUpload_mixin);

// * CONFIRMBOX COMPONENTS
import confirmBox from "./modules/confirmBox/confirmBox_component.vue";
Vue.component('confirmbox', confirmBox)
// * CONFIRMBOX MIXINS
import confirmBox_mixin from '@/modules/confirmBox/confirmBox_mixin.js';
Vue.use(confirmBox_mixin);

import rightPanel from "./components/structural/right-panel.vue";
Vue.component('rightpanel', rightPanel)

// // * SIMULATOR COMPONENTS
import notification from "@/components/notification.vue";
Vue.component('notification', notification)


new Vue({
  router,
  vuetify,
  store,
  i18n,
  created() {
      
    // window.onbeforeunload = function (e) {
    //     console.log('MIXIN CLOSE VIEW')
    //     t.MIX_closeView()

    // }
  },
  render: h => h(App)
}).$mount('#app');
